import React from "react";
import {
  ModalOverlay,
  ModalContent,
  ModalTitle,
  ModalDescription,
  ButtonsContainer,
  DeleteButton,
  CancelButton,
} from "./index.styled";

interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  title?: string;
  description?: string;
}

const DeleteConfirmationModal: React.FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  title = "מחיקה בדיוק?",
  description = "פעולה זו אינה ניתנת לשינוי.",
}) => {
  if (!isOpen) return null;

  const handleOverlayClick = (e: React.MouseEvent) => {
    if (e.target === e.currentTarget) {
      onCancel();
    }
  };

  return (
    <ModalOverlay onClick={handleOverlayClick}>
      <ModalContent>
        <ModalTitle>{title}</ModalTitle>
        <ModalDescription>{description}</ModalDescription>
        <ButtonsContainer>
          <CancelButton onClick={onCancel}>ביטול</CancelButton>
          <DeleteButton onClick={onConfirm}>מחיקה</DeleteButton>
        </ButtonsContainer>
      </ModalContent>
    </ModalOverlay>
  );
};

export default DeleteConfirmationModal;
